import React, { useMemo, useState } from "react";
import useAxios from "hooks/useAxios";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const useFormatFilter = (filter, options = {}) => {
  const { trimStrings = true, validateNonEmpty = true } = options;

  return useMemo(() => {
    if (!filter || typeof filter !== "object") {
      return {};
    }

    const formattedFilter = {};

    Object.entries(filter).forEach(([key, value]) => {
      // Skip if falsy
      if (!value) return;

      let processedValue = value;

      // Trim strings if enabled
      if (trimStrings && typeof value === "string") {
        processedValue = value.trim();

        // Skip empty strings if validation enabled
        if (validateNonEmpty && !processedValue) return;
      }

      formattedFilter[key] = Array.isArray(processedValue)
        ? processedValue
        : [String(processedValue)];
    });

    return formattedFilter;
  }, [filter, trimStrings, validateNonEmpty]);
};

export default function Export({
  url,
  columns,
  filter,
  onClose,
  fileName = "order",
}) {
  const [loading, setLoading] = useState(false);
  const [{ isLoading }, getData] = useAxios();
  const { userToken } = useSelector((state) => state.auth);

  const formattedFilter = useFormatFilter(filter, {
    trimStrings: true,
    validateNonEmpty: true,
  });

  const getReports = async () => {
    setLoading(true);
    const { response: data, error: downloadError } = await getData({
      method: "POST",
      responseType: "blob",
      url,
      data: {
        ...columns,
        ...formattedFilter,
      },
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    });
    setLoading(false);
    if (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}-report.xlsx`); //Download file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (downloadError) {
      console.error("Download error:", downloadError);
      toast.error("مشکلی پیش آمده!");
    }
    onClose();
  };

  return (
    <Button
      fullWidth
      size="large"
      color="success"
      variant="contained"
      onClick={getReports}
      loading={loading || isLoading}
    >
      دانلود
    </Button>
  );
}
